<template>
  <div class="page-inner r" style="min-height: 100vh;">
    <div class="page-title">
      <h3>{{ $t("message.Видеотека") }}</h3>
      <div class="page-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">{{ $t("message.Главная") }}</router-link>
          </li>
          <li class="active breadcrumb-item">{{ $t("message.Видеотека") }}</li>
        </ol>
      </div>
    </div>
    <div id="main-wrapper" v-if="!hasReadPermissions">
      {{ $t("message.Нет_прав_доступа_на_чтение") }}
    </div>
    <div id="main-wrapper" v-if="hasReadPermissions">
      <b-button
        :variant="'success'"
        class="mb-1 float-right"
        @click="addRow()"
        >{{ $t("message.Добавить") }}</b-button
      >
      <b-table
        id="vod_movies-table"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filters"
        :sort-by.sync="sortBy"
      >
        <template slot="HEAD_id" slot-scope="data">
          <b-form-group label="ID">
            <b-form-input
              @click.native.stop
              size="sm"
              :readonly="isBusy"
              v-debounce="1000"
              :value="innerFilter.id"
              @change.native="innerFilter.id = $event.target.value"
              style="width:50px;"
            ></b-form-input>
          </b-form-group>
        </template>

        <template slot="HEAD_image" slot-scope="data"></template>

        <template slot="HEAD_name" slot-scope="data">
          <b-form-group label="Name">
            <b-form-input
              @click.native.stop
              size="sm"
              :readonly="isBusy"
              v-debounce="1000"
              :value="innerFilter.name"
              @change.native="innerFilter.name = $event.target.value"
              style="width:300px;"
            ></b-form-input>
          </b-form-group>
        </template>

        <!-- <template slot="HEAD_actors" slot-scope="data">
          <b-form-group label="Actors">
            <b-form-input
              @click.native.stop
              size="sm"
              :readonly="isBusy"
              v-debounce="1000"
              :value="innerFilter.actors"
              @change.native="innerFilter.actors = $event.target.value"
              style="width:100px;"
            ></b-form-input>
          </b-form-group>
        </template> -->

        <template slot="sort_order" slot-scope="row">
          <div
            v-show="order_update_id != row.item.id"
            @click.stop="updateOrder(row.item)"
            style="width:65px;cursor:text;text-align:center;border-bottom: 1px dotted #999;"
          >
            {{ row.item.sort_order }}
          </div>
          <input
            v-show="order_update_id == row.item.id"
            v-focus="order_update_id == row.item.id"
            v-model="row.item.sort_order"
            v-on:blur="saveOrder(row.item)"
            @keyup.enter="saveOrder(row.item)"
            style="width:65px"
          />
        </template>

        <template slot="actions" slot-scope="row">
          <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <b-button
            size="sm"
            @click.stop="editRow(row.item, row.index, $event.target)"
            class="mr-1"
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button
            size="sm"
            @click.stop="deleteRow(row.item, row.index, $event.target)"
          >
            <i class="fas fa-trash-alt"></i>
          </b-button>
        </template>
        <template slot="status" slot-scope="row">
          <span style="font-size: 1em">
            <i
              class="fa fa-power-off"
              :class="row.item.enabled ? 'text-success' : 'text-danger'"
              :title="row.item.enabled ? 'enabled' : 'disabled'"
              aria-hidden="true"
            ></i>
          </span>
          <span style="font-size: 1.3em">
            <i
              class="fab fa-apple"
              :class="
                row.item.market_accessable ? 'text-success' : 'text-danger'
              "
              :title="
                row.item.market_accessable
                  ? 'visible on markets'
                  : 'hidden from markets'
              "
              aria-hidden="true"
            ></i>
          </span>
        </template>
        <template slot="packages" slot-scope="data">
          <b-badge
            class="mr-1"
            v-for="pack in data.item.vod_packages"
            :key="pack.id"
            >{{ pack.name }}</b-badge
          >
        </template>
        <template slot="image_url" slot-scope="data">
          <img :src="data.item.image_url" :width="64" />
        </template>
        <template slot="genres" slot-scope="data">
          <b-badge
            class="mr-1"
            v-for="pack in data.item.vod_genres"
            :key="pack.id"
            >{{ pack.name }}</b-badge
          >
        </template>
        <template slot="name" slot-scope="row">
          {{ row.item.name }}
          <br />
          <b-button
            :variant="'success'"
            class="mb-1 float-left"
            @click="showVodMovieStreams(row.item)"
            >{{ $t("message.Посмотреть_потоки") }}</b-button
          >
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalRows"
        :per-page="perPage"
        v-model="currentPage"
      ></b-pagination>

      <b-modal
        id="modalInfo"
        @hide="resetModal"
        :ok-title="$t('message.Сохранить')"
        :cancel-title="$t('message.Отмена')"
        :title="$t('message.Видеотека_-_Редактирование')"
        modal-ok
        modal-cancel
        @ok="handleOk"
        size="xl"
        no-close-on-backdrop
      >
        <VodMovieForm :model="vodMovieModel"></VodMovieForm>
      </b-modal>

      <b-modal
        id="modelVodMovieStreams"
        :ok-title="$t('message.Закрыть')"
        :title="$t('message.Потоки')"
        ok-only
        size="xl"
        no-close-on-backdrop
      >
        <VodMovieStreams :model="vodMovieModel"></VodMovieStreams>
      </b-modal>
    </div>
  </div>
</template>

<script>
import VodMovieForm from "./VodMovieForm";
// import VodMovieStreamForm from "./VodMovieStreamForm";
import VodMovieStreams from "./VodMovieStreams";
import Vue from "vue";
import debounce from "./stolencrap/index";
import { focus } from "vue-focus";

export default {
  name: "VodMovies",
  components: {
    VodMovieForm,
    //     VodMovieStreamForm,
    VodMovieStreams
  },
  data() {
    return {
      isBusy: false,
      sortBy: "sort_order",
      fields: [
        { key: "id", sortable: true },
        { key: "image_url", sortable: false },
        { key: "name", sortable: true, thStyle: "width:50%;" },
        { key: "status", sortable: false, thStyle: "min-width:100px;" },
        { key: "sort_order", sortable: true },
        { key: "packages", sortable: false },
        { key: "genres", sortable: false },
        { key: "actions", label: "", tdClass: "actions" }
      ],
      vodMovieModel: {},
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      order_update_id: null,
      innerFilter: {
        id: "",
        name: ""
      }
    };
  },
  computed: {
    hasReadPermissions: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(value => value == "vod_movies:fully_manage").length;
    },
    filters: function() {
      this.currentPage = 1;

      return JSON.stringify(this.innerFilter);
    }
  },
  methods: {
    dataProvider(ctx) {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      // this.isBusy = true
      //console.log(ctx)
      let promise = this.$noname.get("vod_movies", { params: ctx });

      return promise
        .then(data => {
          const items = data.data.items;
          this.totalRows = data.data.total;
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false

          return items;
        })
        .catch(this.$noname.HandleError);
    },
    editRow(item, index, button) {
      this.vodMovieModel = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    showVodMovieStreams(item) {
      this.vodMovieModel = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "modelVodMovieStreams");
    },
    deleteRow(item, index, button) {
      this.$dialog
        .confirm(this.$i18n.t("message.Действительно_удалить_фильм?"))
        .then(response => {
          this.$noname
            .delete("vod_movies", item.id)
            .then(response => {
              this.$root.$emit("bv::refresh::table", "vod_movies-table");
              Vue.notify({
                group: "notify",
                text: this.$i18n.t("message.Запись_успешно_удалена"),
                type: "success"
              });

              //window.location.href = redirectUrl
            })
            .catch(error => {
              Vue.notify({
                group: "notify",
                text:
                  this.$i18n.t("message.Ошибка_удаления_записи") +
                  ":<br>" +
                  error,
                type: "error"
              });
            });
        });
    },
    addRow() {
      this.vodMovieModel = {};
      this.$root.$emit("bv::show::modal", "modalInfo");
    },
    updateOrder(vodmovie) {
      this.order_update_id = vodmovie.id;
    },
    saveOrder(vodmovie) {
      if (vodmovie.sort_order === "" || isNaN(vodmovie.sort_order)) {
        Vue.notify({
          group: "notify",
          text: this.$i18n.t("message.Неверное_значение"),
          type: "warning"
        });
        return;
      }

      this.$noname
        .patch("vod_movies", vodmovie.id, { sort_order: vodmovie.sort_order })
        .then(response => {
          this.order_update_id = null;
          this.$root.$emit("bv::refresh::table", "vod_movies-table");
          Vue.notify({
            group: "notify",
            text: this.$i18n.t("message.Порядок_сохранён"),
            type: "success"
          });
        })
        .catch(error => {
          Vue.notify({
            group: "notify",
            text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
            type: "error"
          });
        });
    },
    handleOk(evt) {
      // Prevent modal from closing
      evt.preventDefault();

      if (
        this.vodMovieModel.image &&
        this.vodMovieModel.image.indexOf("data:image") == -1
      ) {
        this.vodMovieModel.image = null;
      }

      if (this.vodMovieModel.id > 0) {
        this.$noname
          .patch("vod_movies", this.vodMovieModel.id, this.vodMovieModel)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "vod_movies-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
              type: "error"
            });
          });
      } else {
        this.$noname
          .post("vod_movies", this.vodMovieModel)
          .then(response => {
            console.log(response);
            this.$root.$emit("bv::refresh::table", "vod_movies-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text:
                Vue.$t("message.Ошибка_сохранения") +
                ":<br>" +
                error +
                "<br>" +
                error.response.data.message,
              type: "error"
            });
          });
      }
    },
    resetModal() {
      // this.deviceModel = {}
    },
    getLogos() {}
  },
  watch: {
    innerFilters: {
      handler: function() {
        return this.innerFilter;
      },
      deep: true
    }
  },
  directives: { debounce, focus }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/VodMovies.vue